import React from 'react';

export interface Sign2IconProps {}

export const Sign2Icon: React.FC<Sign2IconProps> = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9255 3.72784L12.9653 3.67462C13.1312 3.48108 13.4129 3.4455 13.6202 3.58251L13.6703 3.62037L20.5 9.47406L13.6703 15.3278C13.5345 15.4441 13.3469 15.4791 13.1783 15.4195C12.9365 15.334 12.8016 15.0816 12.8573 14.8375L12.8736 14.7815L14.21 11H12.5C10.567 11 9 12.567 9 14.5V21H6V14.5C6 10.9101 8.91015 8 12.5 8H14.2285L12.8736 4.16668C12.8214 4.01913 12.8417 3.85703 12.9255 3.72784L12.9653 3.67462L12.9255 3.72784Z"
        fill="#192033"
      />
    </svg>
  );
};
